export const LOGIN_REDIRECT_PARAM = 'redirectPath';
